import actions from './actions'

export default function TechnicianDailyReportsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TECHNICIANDAILYREPORT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TECHNICIANDAILYREPORT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TECHNICIANDAILYREPORT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TECHNICIANDAILYREPORT:
      return {
        ...state,
        editing: { technicianDailyReportID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TECHNICIANDAILYREPORT_RECIEVED ||
      actions.UPDATE_TECHNICIANDAILYREPORT_RECIEVED ||
      actions.DELETE_TECHNICIANDAILYREPORT_RECIEVED:
      return {
        ...state,
        editing: { technicianDailyReportID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
